import '../../scss/pages/contact.scss';
import Modal from 'bootstrap/js/dist/modal';
import Popover from "bootstrap/js/dist/popover"
const ModalThankyou = new Modal('#modalThankyou', {
    keyboard: false
})

let wpcf7=document.querySelector(".wpcf7");
if(wpcf7){
    wpcf7.addEventListener(
        "wpcf7mailsent",
        function (event) {
            ModalThankyou.show();
        },
        false
    );
}